import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {IdName} from '../../../models/id-name.model';
import {DynamicCol} from '../../../models/dynamic-col.model';
import {GenericFunctionsUtil} from '../../../utils/generic-functions.util';
import {SiTreeNode} from '../../../models/tree-table.model';
import {ResponsiveService} from '../../../services/responsive.service';
import {ToastService} from '../../../services/toast.service';
import {responsiveBreakpoints} from '../../../constants/responsive.constants';

class ListDynamicItem extends IdName {
  other?: IdName;
  auxId?: number;
  text?: string;
}

class TableItem {
  id: number;
  name?: string;
  surname?: string;
  birthDate?: number;
  documentId?: string;
  highlight?: boolean;
}

class TreeTableItem {
  name?: string;
  auxId?: number;
}

class TreeTableParentItem extends TreeTableItem {
  groupId?: number;
  children?: TreeTableItem[];
}

class TreeTableChildItem extends TreeTableItem {
  id?: number;
  quantity?: number;
  insurance?: string;
  collective?: string;
  professional?: string;
  executionDate?: number;
}

class User {
  id: number;
  name: string;
  username: string;
  email: string;
  address: UserAddress;
  phone: string;
  website: string;
  company: UserCompany;
}

class UserAddress {
  street: string;
  suite: string;
  city: string;
  zipcode: string;
}

class UserCompany {
  name: string;
  catchPhrase: string;
  bs: string;
}

@Component({
  selector: 'si-documentation-table',
  templateUrl: './documentation-table.component.html',
  styleUrls: ['./documentation-table.component.scss']
})
export class DocumentationTableComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  isDesktop: boolean;
  isMobileWidth: boolean;
  responsiveBreakPoints = responsiveBreakpoints;
  listItems = [
    {
      id: 1,
      name: 'Sergio'
    },
    {
      id: 2,
      name: 'Marta'
    },
    {
      id: 3,
      name: 'Antonio'
    },
    {
      id: 4,
      name: 'Eloy'
    }
  ] as IdName[];
  listDynamicSelectorFilterModel: IdName;
  auxId = 0;
  listDynamicItems = [
    {
      id: 1,
      name: 'Sergio'
    },
    {
      id: 2,
      name: 'Marta'
    },
    {
      id: 3,
      name: 'Antonio'
    },
    {
      id: 4,
      name: 'Eloy'
    }
  ] as ListDynamicItem[];

  tableValueSelectedItem: TableItem;
  tableItems = [
    {
      id: 1,
      name: 'Sergio',
      surname: 'Fernández',
      birthDate: 339548400000,
      documentId: '45264815M'
    },
    {
      id: 2,
      name: 'Marta',
      surname: 'Palau',
      birthDate: 339538400000,
      documentId: '49466512H',
      highlight: true
    },
    {
      id: 3,
      name: 'Antonio',
      surname: 'Mota',
      birthDate: 339248400000,
      documentId: '45264815M'
    },
    {
      id: 4,
      name: 'Eloy',
      surname: 'Galdón',
      birthDate: 339558400000,
      documentId: '49466512H'
    },
    {
      id: 5,
      name: 'Sergio',
      surname: 'Fernández',
      birthDate: 339848400000,
      documentId: '45264815M'
    },
    {
      id: 6,
      name: 'Marta',
      surname: 'Palau',
      birthDate: 339748400000,
      documentId: '49466512H'
    },
    {
      id: 7,
      name: 'Antonio',
      surname: 'Mota',
      birthDate: 339544400000,
      documentId: '45264815M'
    }
  ] as TableItem[];
  resetTable = 1;
  reloadTable = 0;

  tablePathSelectedItems: User[];
  dynamicCols: DynamicCol[] = [
    {id: 1, internalOrder: 1, field: 'username', name: 'Usuario', sortable: true},
    {id: 2, internalOrder: 2, field: 'phone', name: 'Teléfono', sortable: true},
    {id: 3, internalOrder: 3, field: 'website', name: 'Website'},
    {id: 4, internalOrder: 4, field: 'email', name: 'Email', width: '100px'}
  ];

  // Default checked dynamic cols
  selectedColumns: DynamicCol[] = [
    this.dynamicCols[0]
  ];
  nonSelectedColumns: DynamicCol[] = this.getNonSelectedColumns(this.selectedColumns);

  // Default checked dynamic cols
  selectedColumns2: DynamicCol[] = [
    this.dynamicCols[0]
  ];
  nonSelectedColumns2: DynamicCol[] = this.getNonSelectedColumns(this.selectedColumns2);
  siStorageManualSet = 0;

  // Default checked dynamic cols
  selectedColumns3: DynamicCol[] = [
    this.dynamicCols[0],
    this.dynamicCols[1],
    this.dynamicCols[2],
    this.dynamicCols[3]
  ];
  nonSelectedColumns3: DynamicCol[] = this.getNonSelectedColumns(this.selectedColumns2);

  tablePathDragDropCols = [
    {id: 1, internalOrder: 1, field: 'username', name: 'Usuario', sortable: true},
    {id: 2, internalOrder: 2, field: 'phone', name: 'Teléfono', sortable: true},
    {id: 3, internalOrder: 3, field: 'website', name: 'Website'},
    {id: 4, internalOrder: 4, field: 'email', name: 'Email', width: '100px'}
  ];

  treeTableItems = [
    {
      id: 1,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    },
    {
      id: 2,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    },
    {
      id: 3,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    },
    {
      'groupId': 10,
      name: 'KIT MATERIALES 1',
      'children': [
        {
          id: 277204,
          name: 'VISITA HOSPITLARIA BASE',
          quantity: 1.0,
          insurance: 'PRIVADOS',
          collective: 'Privados todos',
          professional: 'SYSADMIN SYSADMIN',
          executionDate: 1614034800000
        },
        {
          'groupId': 11,
          name: 'KIT MATERIALES 2',
          'children': [
            {
              id: 4,
              name: 'VISITA HOSPITALARIA BASE',
              quantity: 1.0,
              insurance: 'PRIVADOS',
              collective: 'Privados todos',
              professional: 'SYSADMIN SYSADMIN',
              executionDate: 1614034800000
            } as TreeTableChildItem
          ]
        } as TreeTableParentItem
      ]
    } as TreeTableParentItem,
    {
      'groupId': 12,
      name: 'KIT MATERIALES 1',
      'children': [
        {
          id: 5,
          name: 'VISITA HOSPITLARIA BASE',
          quantity: 1.0,
          insurance: 'PRIVADOS',
          collective: 'Privados todos',
          professional: 'SYSADMIN SYSADMIN',
          executionDate: 1614034800000
        },
        {
          'groupId': 13,
          name: 'KIT MATERIALES 2',
          'children': [
            {
              id: 6,
              name: 'VISITA HOSPITALARIA BASE',
              quantity: 1.0,
              insurance: 'PRIVADOS',
              collective: 'Privados todos',
              professional: 'SYSADMIN SYSADMIN',
              executionDate: 1614034800000
            } as TreeTableChildItem
          ]
        } as TreeTableParentItem
      ]
    } as TreeTableParentItem,
    {
      id: 7,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    },
    {
      id: 8,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    },
    {
      id: 9,
      name: 'VISITA HOSPITALARIA BASE',
      quantity: 1.0,
      insurance: 'PRIVADOS',
      collective: 'Privados todos',
      professional: 'SYSADMIN SYSADMIN',
      executionDate: 1614034800000
    }
  ] as TreeTableItem[];
  treeTableSelectedItems: SiTreeNode[];
  isTreeTableCheckDisabled = false;
  treeTableDynamicSelectorFilterModel: IdName;
  resetTreeTable = 1;
  reloadTreeTable = 0;

  constructor(
    private responsiveService: ResponsiveService,
    private toastService: ToastService
  ) {
    this.setLogic();
  }

  setLogic(): void {
    this.isDesktop = this.responsiveService.isDesktop();
    this.subscriptions.push(this.responsiveService.getResponsiveStoreObservable().subscribe((responsiveStore) => {
      this.isMobileWidth = responsiveStore.currentWindowWidth < this.responsiveBreakPoints.XS;
    }));
  }

  onSelectListDynamicItem(): void {
    const newItem = {...this.listDynamicSelectorFilterModel} as ListDynamicItem;
    newItem.auxId = this.auxId++;
    if (!this.listDynamicItems) {
      this.listDynamicItems = [];
    }

    this.listDynamicItems.unshift(newItem);

    // We need to wait the selectorComponent has finished its logic.
    setTimeout(() => {
      this.listDynamicSelectorFilterModel = null;
    }, 100);
  }

  async onRowSelectValue(row): Promise<void> {
    console.log('Row selected:');
    console.log(row);
    await this.toastService.info('Row selected');
  }

  applyFilters(): void {
    this.resetTableFunction();
  }

  resetTableFunction(): void {
    this.resetTable++;
  }

  reloadTableFunction(): void {
    this.reloadTable++;
  }

  onChangeSelectedColumns(selectedColumns): void {
    this.nonSelectedColumns = this.getNonSelectedColumns(selectedColumns);
    this.sortSelectedColumns();
  }

  onChangeSelectedColumns2(selectedColumns: DynamicCol[]): void {
    this.nonSelectedColumns2 = this.getNonSelectedColumns(selectedColumns);
    this.sortSelectedColumns2();
  }

  setStorageSelectedColumns2(): void {
    this.siStorageManualSet++;
  }

  sortSelectedColumns(): void {
    this.selectedColumns.sort((x, y) => x.internalOrder - y.internalOrder);
  }

  sortSelectedColumns2(): void {
    this.selectedColumns2.sort((x, y) => x.internalOrder - y.internalOrder);
  }

  getNonSelectedColumns(selectedColumns: DynamicCol[]): DynamicCol[] {
    return this.dynamicCols.filter(x => !selectedColumns.find(col => col.field === x.field));
  }

  onRowSelect(event: any): void {
    event.data.checked = true;
  }

  onRowUnselect(event: any): void {
    event.data.checked = false;
  }

  onClickDisableTreeTableCheck(): void {
    this.isTreeTableCheckDisabled = !this.isTreeTableCheckDisabled;
  }

  isRowDisabled(rowData: User): boolean {
    return this.isTreeTableCheckDisabled;
  }

  onSelectTreeTableDynamicItem(): void {
    const newItem = {...this.treeTableDynamicSelectorFilterModel} as TreeTableItem;
    newItem.auxId = this.auxId++;
    if (!this.treeTableItems) {
      this.treeTableItems = [];
    }

    this.treeTableItems.unshift(newItem);
    this.treeTableItems = GenericFunctionsUtil.deepClone(this.treeTableItems);

    // We need to wait the selectorComponent has finished its logic.
    setTimeout(() => {
      this.treeTableDynamicSelectorFilterModel = null;
    }, 100);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
